import { teamMembers } from '@/mocks/team';

type Member = (typeof teamMembers)[number];

function Portrait({ m }: { m: Member }) {
  return (
    <figure className="group flex flex-col">
      <div className="w-full aspect-[4/5] overflow-hidden bg-background-100">
        <img src={m.image} alt={`${m.name}, ${m.role}`} title={`${m.name} — ${m.specialisation}`} className="w-full h-full object-cover object-top media-zoom" />
      </div>
      <figcaption className="mt-4 pt-4 border-t border-foreground-950/15">
        <p className="font-heading text-[22px] leading-tight text-foreground-950 transition-colors duration-300 ease-ui group-hover:text-accent-600">{m.name}</p>
        <p className="mt-1 text-[14px] text-foreground-600">{m.role}</p>
        <p className="mt-3 inline-block bg-background-100 px-2.5 py-1 font-label text-[12px] tracking-[0.04em] text-foreground-800">{m.specialisation}</p>
      </figcaption>
    </figure>
  );
}

export default function TeamGrid() {
  const [a, b, c, d, e, f] = teamMembers;
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="wrap">
        <div className="mx-auto max-w-[1280px]">
          <div data-reveal-stagger className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 items-end">
            <div className="lg:col-span-7">
              <p className="flex items-center gap-3 font-label text-[12px] md:text-[13px] tracking-[0.2em] text-foreground-600">
                <span className="inline-block w-2 h-2 bg-accent-500"></span>OUR TEAM
              </p>
              <h2 className="mt-5 font-display font-normal text-[clamp(2rem,3.4vw,3rem)] leading-[1.1] tracking-[-0.015em] text-foreground-950">
                The people behind the perspective.
              </h2>
            </div>
            <p className="lg:col-span-5 text-[16px] leading-[1.6] text-foreground-700 max-w-md">
              A small team of senior advisors, search specialists and coaches — each bringing a different lens, all sharing the same commitment to people.
            </p>
          </div>

          <div className="mt-12 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-5 md:gap-x-6 gap-y-10 md:gap-y-12">
            <Portrait m={a} />
            <Portrait m={b} />
            <Portrait m={c} />
            <div className="cut-br bg-accent-500 text-background-50 p-6 md:p-8 flex flex-col justify-between min-h-[320px] sm:min-h-0 sm:aspect-[4/5]">
              <span className="font-label text-[12px] tracking-[0.18em]">OUR PROMISE</span>
              <p className="font-display font-normal text-[24px] md:text-[26px] leading-[1.2]">
                Every client works directly with a senior advisor — from first conversation to final outcome.
              </p>
            </div>
            <Portrait m={d} />
            <Portrait m={e} />
            <Portrait m={f} />
            <div className="hidden lg:flex flex-col justify-end border-t border-foreground-950/15 pt-5 aspect-[4/5]">
              <p className="text-[15px] leading-[1.6] text-foreground-700">
                Diverse backgrounds across search, HR leadership, coaching and organisational design.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}